import { Document, Page, StyleSheet } from '@react-pdf/renderer';
import React from "react";
import CommonPdfBusinessSkillsSection from "./CommonPdfBusinessSkillsSection";
import CommonPdfDiplomasSection from "./CommonPdfDiplomasSection";
import CommonPdfExperiencesSection from "./CommonPdfExperiencesSection";
import CommonPdfFooter from "./CommonPdfFooter";
import CommonPdfHeader from "./CommonPdfHeader";
import CommonPdfHobbiesSection from "./CommonPdfHobbiesSection";
import CommonPdfIntroductionSection from "./CommonPdfIntroductionSection";
import CommonPdfLanguagesSkillsSection from "./CommonPdfLanguagesSkillsSection";
import { extractResumeProperties } from "../../../hooks/useResumeProperties";

export default function CommonPdf( { resumeData, translations } ) {

    const { isExperienceHidden } = extractResumeProperties( resumeData );

    const styles = StyleSheet.create( {
        page: {
            flexDirection: 'column',
            fontSize: '10pt',
            fontFamily: 'Arial, sans-serif',
            textAlign: 'justify',
            padding: '110px 40px 80px',
        },
    } );

    return (
        <Document>
            <Page size="A4" style={ styles.page }>
                <CommonPdfHeader resumeData={ resumeData } translations={ translations }/>
                <CommonPdfIntroductionSection resumeData={ resumeData } translations={ translations }/>
                <CommonPdfLanguagesSkillsSection resumeData={ resumeData } translations={ translations }/>
                <CommonPdfBusinessSkillsSection resumeData={ resumeData } translations={ translations }/>
                { !isExperienceHidden && (
                    <CommonPdfExperiencesSection resumeData={ resumeData } translations={ translations }/>
                ) }
                <CommonPdfDiplomasSection resumeData={ resumeData } translations={ translations }/>
                <CommonPdfHobbiesSection resumeData={ resumeData } translations={ translations }/>
                <CommonPdfFooter/>
            </Page>
        </Document>
    );
}
